export default class BaseModel {
	constructor(options) {
		typeof options.id !== "undefined" && (this.id = options.id);
		typeof options.createdAt !== "undefined" &&
			(this.createdAt = options.createdAt); // Type: firebase.firestore.Timestamp
	}
}
